module.exports = __webpack_public_path__ + "static/media/logo-melag.2d9b6c93.png";